import { render, staticRenderFns } from "./app-download.vue?vue&type=template&id=a03722c4&"
import script from "./app-download.vue?vue&type=script&lang=js&"
export * from "./app-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports